
// Find out what cookies are supported. Returns:
// null - no cookies
// false - only session cookies are allowed
// true - session cookies and persistent cookies are allowed
function getCookieSupport() {
    var persist= true;
    do {
        var c= 'gCStest='+Math.floor(Math.random()*100000000);
        document.cookie= persist? c+';expires=Tue, 01-Jan-2030 00:00:00 GMT' : c;
        if (document.cookie.indexOf(c)!==-1) {
            document.cookie= c+';expires=Sat, 01-Jan-2000 00:00:00 GMT';
            return persist;
        }
    } while (!(persist= !persist));
    return null;
}

function reloadPageIfNecessary(preference) {
  if (preference == 'none') {
    return;
  } else {
    var current = window.location.href;
    if (current.match('#' + preference) || current.match('/' + preference + '/')) {
    } else {
      if (current.match('#arena') || current.match('#paper') || current.match('#online') ) {
        window.location = "#" + preference;
      } else if (current.match('/online/')) {
        window.location = current.replace('/online/', '/' + preference + '/');
      } else if (current.match('/paper/')) {
        window.location = current.replace('/paper/', '/' + preference + '/');
      } else if (current.match('/arena/')) {
        window.location = current.replace('/arena/', '/' + preference + '/');
      }
    }
  }
}

function setDefaultTypeSwitcher(preference) {
  ['paper', 'arena', 'online'].forEach(function(type) {
    var el = document.getElementById('default-toggle-' + type);
    if (el) el.classList.remove('active');
  });
  var activeId = 'default-toggle-' + (preference === 'online' ? 'online' : preference === 'arena' ? 'arena' : 'paper');
  var activeEl = document.getElementById(activeId);
  if (activeEl) activeEl.classList.add('active');
}

document.addEventListener('DOMContentLoaded', function() {
  var preference = Cookies.get('type-preference');
  setDefaultTypeSwitcher(preference);

  ['online', 'paper', 'arena'].forEach(function(type) {
    var btn = document.getElementById('default-toggle-' + type);
    if (!btn) return;
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      Cookies.set('type-preference', type, { expires: 3650, path: '/' });
      setDefaultTypeSwitcher(type);
      reloadPageIfNecessary(type);
    });
  });
});
